import { GenericService } from "./Generic.service";

export class CollaboratorService extends GenericService<string> {
  readonly URI: string = "Colaborador";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async upload(body: any, id: string) {
    return await super.postByResourceHeadersTwo(body, id, "Upload/CSV");
  }

  public async BuscarUsuariosDoResponsavel(body: any) {
    return await super.postByResource(body, "BuscarUsuariosDoResponsavel")
  }

  public async BuscarDependentes(body: any) {
    return await super.postByResource(body, "BuscarDependentes")
  }

}
